/**
 * Routes consultation notifications to the correct dashboard tab.
 * Prefer API `consultationNavTarget` ("booker" | "host"); fall back to notifier email.
 */
export function getConsultationDashboardPath(
  notificationFragment: Record<string, any> | null | undefined,
  loggedInUserEmail: string | null | undefined
): string {
  const raw = notificationFragment || {};
  const target = String(
    raw.consultationNavTarget ?? raw.ConsultationNavTarget ?? ""
  )
    .toLowerCase()
    .trim();
  if (target === "booker") {
    return "/user-dashboard/my-consultation";
  }
  if (target === "host") {
    return "/user-dashboard/pending-consultations";
  }

  const notifier = String(
    raw.notifierUserEmail ?? raw.NotifierUserEmail ?? ""
  ).toLowerCase();
  const logged = (loggedInUserEmail || "").toLowerCase();
  if (logged && notifier && logged === notifier) {
    return "/user-dashboard/my-consultation";
  }
  return "/user-dashboard/pending-consultations";
}
